import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  getAllSitePropertiesService,
  updateSitePropertiesService
} from '../../network/services/systemManagement/sitePropertiesService'

/**
 * Get All Site Configs
 */
export const fetchAllProperties = createAsyncThunk(
  'fetch/site-properties',
  async (data, thunkApi) => {
    try {
      const res = await getAllSitePropertiesService(data)
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const updateSiteProperties = createAsyncThunk(
  'create/update-siteProperties',
  async ({ data, onSuccess }, thunkApi) => {
    try {
      const res = await updateSitePropertiesService(data)
      onSuccess()
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)
